import axios from 'axios';

const instance = axios.create({
    // baseURL: 'http://' + window.location.hostname + ":8080/ZowellERP",//本地
    baseURL: "http://zwerp.zwcloud.wang:8088/ZowellERP",//正式
    // baseURL: 'http://' + window.location.hostname + ":8086",
    timeout: 10000
});

instance.defaults.withCredentials = true;
instance.defaults.headers.post['Content-Type'] = 'application/json';
//错误处理
// instance.interceptors.response.use(function(response) {
//     return response;
// }, util.catchError);

export default instance;



// WEBPACK FOOTER //
// ./src/api/index.js